import moment from "moment"

export function copyDateTime(date) {
    const todayDate = moment()
    const newDate = date.set({
        "hour": todayDate.hour(),
        "minute": todayDate.minutes(),
        "second": todayDate.seconds()
    })
    return newDate.format()
}


// WEBPACK FOOTER //
// ./src/state/helpers/dateHelpers.ts